import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  windowWidth: 0,
  fetchingContent: true,
  error: false,
  sidebarOpen: true,
  firstRun: true,
  cardSelectState: false,
  formRender: false,
  dataRenderMethod: "chart",
  fromHomeCard: false,
  backToHome: false,
  darkTheme: true,
  settingOpen: false,
};

const uiStateSlice = createSlice({
  name: "ui state",
  initialState,
  reducers: {
    setWindowWidth(state, action) {
      state.windowWidth = action.payload;
    },
    setSideBarOpenState(state, action) {
      state.sidebarOpen = action.payload;
    },
    setCardSelectState(state, action) {
      state.cardSelectState = action.payload;
    },
    setFormRenderState(state, action) {
      state.formRender = action.payload;
    },
    setDataRenderMethod(state, action) {
      state.dataRenderMethod = action.payload;
    },
    updateFetchingContentStatus(state, action) {
      state.fetchingContent = action.payload;
    },
    updateErrorState(state, action) {
      state.error = action.payload;
    },
    updateFirstRunState(state, action) {
      state.firstRun = action.payload;
    },
    updateFromHomeCardState(state, action) {
      state.fromHomeCard = action.payload;
    },
    updateBackToHomeState(state, action) {
      state.backToHome = action.payload;
    },
    setDarkTheme(state, action) {
      state.darkTheme = action.payload;
    },
    setSettingOpenState(state, action) {
      state.settingOpen = action.payload;
    },
    logout(state) {},
  },
});

export const uiStateActions = uiStateSlice.actions;

export default uiStateSlice.reducer;
